<template>
  <div id="data-view">
    <dv-full-screen-container>
      <div class="main-header">
        <div class="mh-left"></div>
        <div class="mh-middle">数据开发中心 - 预警监控大屏</div>
        <div class="mh-right">
          <div class="full-screen">
            <span v-if="full" class="fa fa-compress fz20 pointer" @click="exitFullScreen"></span>
            <span v-else class="fa fa-expand fz20 pointer" @click="fullScreen"></span>
          </div>
        </div>
      </div>

      <dv-border-box-1 class="main-container">
        <dv-border-box-10 class="left-chart-container">
          <Left-Chart-1 />
          <Left-Chart-2 />
          <Left-Chart-3 />
        </dv-border-box-10>

        <div class="right-main-container">
          <div class="rmc-top-container">
            <dv-border-box-10 class="rmctc-left-container">
              <Center-Cmp />
            </dv-border-box-10>

            <div class="rmctc-right-container">
              <dv-border-box-10 class="rmctc-chart">
                <Right-Chart />
              </dv-border-box-10>
            </div>
          </div>

          <dv-border-box-4 class="rmc-bottom-container">
            <Bottom-Charts />
          </dv-border-box-4>
        </div>
      </dv-border-box-1>
    </dv-full-screen-container>
  </div>
</template>

<script>
import LeftChart1 from './LeftChart1';
import LeftChart2 from './LeftChart2';
import LeftChart3 from './LeftChart3';
import CenterCmp from './CenterCmp';
import RightChart from './RightChart';
import BottomCharts from './BottomCharts';

export default {
  name: 'DataView',
  components: {
    LeftChart1,
    LeftChart2,
    LeftChart3,
    CenterCmp,
    RightChart,
    BottomCharts
  },
  data() {
    return {
      full: false
    };
  },
  methods: {
    fullScreen() {
      let el = document.documentElement;
      let requestMethod = el.requestFullscreen || el.wekitRequestFullscreen || el.mozRequestFullscreen || el.msRequestFullscreen;
      if (requestMethod) {
        requestMethod.call(el);
      } else {
        let wscript = new ActiveXObject('WScript:Shell');
        wscript.SendKeys('{F11}');
      }
      this.full = true;
    },
    exitFullScreen() {
      let exitMethod = document.exitFullscreen || document.wekitExitFullscreen || document.mozExitFullscreen || document.msExitFullscreen;
      if (exitMethod) {
        exitMethod.call(document);
      } else {
        let wscript = new ActiveXObject('WScript:Shell');
        wscript.SendKeys('{F11}');
      }
      this.full = false;
    }
  }
};
</script>

<style lang="less">
#data-view {
  width: 100%;
  height: 100%;
  background-color: #030409;
  color: #fff;

  #dv-full-screen-container {
    background-image: url('./img/bg.png');
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }

  .main-header {
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .mh-left {
      font-size: 20px;
      color: rgb(1, 134, 187);

      a:visited {
        color: rgb(1, 134, 187);
      }
    }

    .mh-middle {
      font-size: 30px;
    }

    .mh-left,
    .mh-right {
      padding: 0 30px;
    }
  }

  .main-container {
    height: calc(~'100% - 80px');

    .border-box-content {
      padding: 20px;
      box-sizing: border-box;
      display: flex;
    }
  }

  .left-chart-container {
    width: 22%;
    padding: 0px;
    box-sizing: border-box;

    .border-box-content {
      flex-direction: column;
    }
  }

  .right-main-container {
    width: 78%;
    padding-left: 10px;
    box-sizing: border-box;
  }

  .rmc-top-container {
    height: 65%;
    padding-bottom: 10px;
    display: flex;
  }

  .rmctc-left-container {
    width: 65%;
  }

  .rmctc-right-container {
    padding-left: 10px;
    width: 35%;
  }

  .rmc-bottom-container {
    height: 35%;
  }

  .rmctc-chart {
    height: 100%;
  }
}
</style>
